import { RateSourceDTO } from '../types/dto/rate-source.dto';
import { RateSource } from '../types/rate-source';

/**
 * Maps rate source from DTO to application domain model.
 *
 * NOTE: SENIORITY and ROLE are temporarily mapped to GlobalDefaultRate (ORGANIZATION)
 * until post-MVP when these features will be fully implemented.
 * TODO: Restore original mapping when seniority-based and role-based rates are ready.
 */
export const mapRateSourceFromDTO = (dto: RateSourceDTO): RateSource => {
  switch (dto) {
    case RateSourceDTO.FLAT:
      return RateSource.FlatRate;
    case RateSourceDTO.USER:
      return RateSource.UserExternalRate;
    case RateSourceDTO.SENIORITY:
      // TODO: Post-MVP - restore: return RateSource.SeniorityBasedRate;
      return RateSource.GlobalDefaultRate;
    case RateSourceDTO.ROLE:
      // TODO: Post-MVP - restore: return RateSource.RoleBasedRate;
      return RateSource.GlobalDefaultRate;
    case RateSourceDTO.PROJECT:
      return RateSource.ProjectBased;
    case RateSourceDTO.ORGANIZATION:
      return RateSource.GlobalDefaultRate;
    case RateSourceDTO.RATE_CARD:
      return RateSource.ProjectRateCard;
    case RateSourceDTO.CUSTOM:
      return RateSource.Custom;
    default:
      return RateSource.UserExternalRate;
  }
};

/**
 * Maps rate source from application domain model to DTO.
 */
export const mapRateSourceToDTO = (rateSource: RateSource): RateSourceDTO => {
  switch (rateSource) {
    case RateSource.FlatRate:
      return RateSourceDTO.FLAT;
    case RateSource.UserExternalRate:
      return RateSourceDTO.USER;
    case RateSource.SeniorityBasedRate:
      return RateSourceDTO.SENIORITY;
    case RateSource.RoleBasedRate:
      return RateSourceDTO.ROLE;
    case RateSource.GlobalDefaultRate:
      return RateSourceDTO.ORGANIZATION;
    case RateSource.ProjectRateCard:
      return RateSourceDTO.RATE_CARD;
    case RateSource.Custom:
      return RateSourceDTO.CUSTOM;
    case RateSource.ProjectBased:
      return RateSourceDTO.PROJECT;
    default:
      return RateSourceDTO.USER;
  }
};
